import Filter from '../../../components/DataTable/@types/Filter';

export default function useVendorsServerFilters(): Filter[] {
  const filters: Filter[] = [];

  return filters;
}
